var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-print" },
    [
      _c(
        "div",
        {
          staticClass: "print-empty-wrap",
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
            "flex-direction": "column",
          },
          style: { minHeight: _vm.emptyMinHeight },
        },
        [
          _vm._m(0),
          _vm.printList.length == 0
            ? _c("div", { staticStyle: { "margin-top": "30px" } }, [
                _vm._v("准考证打印时间未开放，敬请等待!"),
              ])
            : _c("div", { staticStyle: { "margin-top": "30px" } }, [
                _vm._v("准考证已生成，请下载打印!"),
              ]),
        ]
      ),
      _vm.printList.length > 0
        ? _c(
            "div",
            {
              staticStyle: {
                color: "#A40000",
                "font-size": "16px",
                "font-weight": "bold",
                margin: "100px 0 10px",
              },
            },
            [_vm._v(" 相关下载附件")]
          )
        : _vm._e(),
      _vm._l(_vm.printList, function (item) {
        return _c(
          "div",
          {
            key: item.ticketType + "-" + item.registrationId,
            staticClass: "download-item",
            on: {
              click: function ($event) {
                return _vm.handleDownload(item)
              },
            },
          },
          [
            _c("i", {
              staticClass: "el-icon-folder-opened",
              staticStyle: { "font-size": "18px" },
            }),
            _c("div", { staticClass: "download-name" }, [
              _vm._v(_vm._s(_vm.ticketFileName(item))),
            ]),
            _c(
              "el-tag",
              {
                staticStyle: { "margin-left": "8px" },
                attrs: {
                  size: "mini",
                  type: item.ticketType === 2 ? "warning" : "",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(item.ticketType === 2 ? item.psyStageName : "笔试") +
                    " "
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "download-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "mini" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handlePreview(item)
                      },
                    },
                  },
                  [_vm._v("预览")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "mini" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleDownload(item)
                      },
                    },
                  },
                  [_vm._v("下载")]
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm.previewUrl
        ? _c("div", { staticClass: "pdf-preview" }, [
            _c(
              "div",
              { staticClass: "pdf-preview-header" },
              [
                _c("span", [_vm._v("文件预览")]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "mini" },
                    on: { click: _vm.revokePreview },
                  },
                  [_vm._v("关闭预览")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.previewLoading,
                    expression: "previewLoading",
                  },
                ],
              },
              [
                _c("iframe", {
                  staticClass: "pdf-frame",
                  attrs: { src: _vm.previewUrl },
                }),
              ]
            ),
            _c("div", { staticClass: "pdf-tip" }, [
              _vm._v(
                "若预览为空白（部分手机浏览器不支持），请点击「下载」用本地 PDF 阅读器打开。"
              ),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "print-btn" }, [
      _c("i", {
        staticClass: "el-icon-printer",
        staticStyle: { "font-size": "66px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }